export enum ManualPaymentSource {
  CHECK = 'Check',
  CASH = 'Cash',
  BANK_TRANSFER = 'Bank Transfer',
  CREDIT_CARD = 'Credit Card'
}
